/**
 * Черновик комментария, переживающий закрытие дравера / переключение записи.
 * Хранится в sessionStorage (живёт в рамках вкладки, переживает reload) —
 * ключ на запись, чтобы черновики разных задач не смешивались.
 */

export interface PendingImage {
  url: string;
  fileName: string;
}

export interface CommentDraft {
  body: string;
  images: PendingImage[];
}

function draftKeyOf(itemId: string): string {
  return `lens.comment-draft:${itemId}`;
}

export function readCommentDraft(itemId: string): CommentDraft | null {
  try {
    const raw = sessionStorage.getItem(draftKeyOf(itemId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CommentDraft>;
    return {
      body: typeof parsed.body === 'string' ? parsed.body : '',
      images: Array.isArray(parsed.images)
        ? parsed.images.filter(
            (img): img is PendingImage =>
              !!img && typeof img.url === 'string' && typeof img.fileName === 'string',
          )
        : [],
    };
  } catch {
    return null;
  }
}

export function writeCommentDraft(itemId: string, draft: CommentDraft): void {
  try {
    if (!draft.body && draft.images.length === 0) {
      sessionStorage.removeItem(draftKeyOf(itemId));
    } else {
      sessionStorage.setItem(draftKeyOf(itemId), JSON.stringify(draft));
    }
  } catch {
    // quota / private mode — черновик просто не сохранится
  }
}
